import { render, staticRenderFns } from "./studentTheoryIndex.vue?vue&type=template&id=e3506b44&scoped=true"
import script from "./studentTheoryIndex.vue?vue&type=script&lang=js"
export * from "./studentTheoryIndex.vue?vue&type=script&lang=js"
import style0 from "./studentTheoryIndex.vue?vue&type=style&index=0&id=e3506b44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3506b44",
  null
  
)

export default component.exports